export const generateQueryString = (data = {}) => {
  let params = data;

  if (data instanceof FormData === true) {
    params = {};

    data.forEach((value, key) => (params[key] = value));
  }

  for (const key in params) {
    if (params[key] === "") {
      delete params[key];
    }
  }

  return new URLSearchParams(params);
};

export const updateQueryParams = (params = []) => {
  const url = new URL(window.location.href);
  const updatedParams = new URLSearchParams(url.search);

  params.forEach((param) => {
    const key = param[0];
    const value = param[1] ?? false;

    if (value) {
      updatedParams.set(key, value);
    } else {
      updatedParams.delete(key);
    }
  });

  url.search = updatedParams.toString();

  return url;
};

export const trackGoogleAnalytics = (event) => {
  if (window.dataLayer) {
    window.dataLayer.push(event);
  }
};
